<template>
  <v-progress-circular indeterminate :size="size" :color="color">
    <span>{{ msg }}</span>
  </v-progress-circular>
</template>

<script>
// Libraries
import { mapGetters } from "vuex";
// Components

export default {
  name: "loading",
  props: ["color", "msg", "size"],
  data: () => ({
    loading: {
      overall: false,
    },
  }),
  methods: {
    /* API Calls */
    // GET
    // POST
    /* Main */
    /* Misc */
  },
  computed: {
    ...mapGetters([]),
  },
};
</script>

<style></style>
